// An App save the server refused for its tables, in the person's words. The code is the tool result's own
// `error` (src/apps/tracer/authoring-failure.mjs); the model explains the rows and the choice in its answer.
import type { AppVersionsCopyKey } from '@/i18n/ns/app-versions';

const REFUSALS: Readonly<Record<string, AppVersionsCopyKey>> = {
  // Nothing was saved: saved rows break a stricter field.
  app_schema_change_needs_review: 'saveRefusedRows',
  // The version is saved; its tables follow on the next save of the same source.
  app_schema_change_pending: 'saveTablesPending',
};

export function appSaveRefusal(
  error: unknown,
  copy: Readonly<Record<AppVersionsCopyKey, string>>,
): string | null {
  return typeof error === 'string' && Object.hasOwn(REFUSALS, error) ? copy[REFUSALS[error]] : null;
}
